import { NoValuePlaceholder } from '@aleph/shared-components';
import { SelectCellRenderer } from '@aleph/supergrid';
import { ICellRendererParams } from 'ag-grid-community';

export const SelectRenderer = (params: ICellRendererParams & { disabled?: boolean }) => {
	const Component = !params?.data?.isCreate || params.disabled
		? <SelectCellRenderer {...params} />
		: <NoValuePlaceholder />;

	return Component;
};
